// Block: Opinie — rotating testimonials.
// Built to blocks/opinie/script.min.js by jarvis2, enqueued per-block.
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('#block-opinie, .block--opinie').forEach(function (root) {
            var reviews;
            try { reviews = JSON.parse(root.getAttribute('data-reviews') || '[]'); }
            catch (e) { reviews = []; }
            if (reviews.length < 2) return;

            var quoteEl = root.querySelector('[data-role="quote"]');
            var whoEl   = root.querySelector('[data-role="who"]');
            var pager   = root.querySelector('[data-role="pager"]');
            if (!quoteEl || !whoEl) return;

            var dots = pager ? Array.prototype.slice.call(pager.querySelectorAll('button')) : [];
            var current = 0, timer = null;

            function show(i) {
                current = i;
                quoteEl.style.opacity = 0;
                whoEl.style.opacity = 0;
                setTimeout(function () {
                    var r = reviews[i];
                    quoteEl.textContent = '„' + r.quote + '”';
                    whoEl.innerHTML = '<strong>' + escapeHtml(r.author) + '</strong>' + escapeHtml(r.meta);
                    quoteEl.style.transition = whoEl.style.transition = 'opacity .6s ease';
                    quoteEl.style.opacity = 1;
                    whoEl.style.opacity = 1;
                    dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
                }, 280);
            }

            function escapeHtml(s) {
                var d = document.createElement('div');
                d.textContent = s == null ? '' : s;
                return d.innerHTML;
            }

            function start() { timer = setInterval(function () { show((current + 1) % reviews.length); }, 7500); }
            function reset() { if (timer) clearInterval(timer); start(); }

            dots.forEach(function (d) {
                d.addEventListener('click', function () { show(parseInt(d.dataset.i, 10)); reset(); });
            });
            start();
        });
    });
})();
